import { IntlShape, MessageDescriptor } from 'react-intl';
import { isAssetStyleId, isWaveformShape } from 'fym-shared/src/music24/assetStyles';
import { isReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';
import { releaseThemeMessages } from '../themes/releaseThemeMessages';
import { assetStyleMessages, waveformShapeMessages } from '../themes/assetStyleMessages';
import { formatLength } from '../viewer/viewerFacts';
import { RevisionEntry, RevisionFactKey } from './revisionModel';
import { revisionMessages } from './revisionMessages';

/** The label of each fact of a revision (design d1 "what changed", d2 Compare). */
export const revisionFactLabels: Record<RevisionFactKey, MessageDescriptor> = {
  theme: revisionMessages.factTheme,
  style: revisionMessages.factStyle,
  text: revisionMessages.factText,
  colours: revisionMessages.factColours,
  length: revisionMessages.factLength,
};

/** The words of one raw fact value (`revisionFact`): a theme name, a style name, "0:15". */
export function revisionFactText(intl: IntlShape, key: RevisionFactKey, value: string | null): string {
  if (value === null) {
    return '—';
  }
  switch (key) {
    case 'theme':
      return isReleaseThemeId(value) ? intl.formatMessage(releaseThemeMessages[value].name) : value;
    case 'style':
      if (isAssetStyleId(value)) {
        return intl.formatMessage(assetStyleMessages[value].name);
      }
      return isWaveformShape(value) ? intl.formatMessage(waveformShapeMessages[value]) : value;
    case 'text':
      return value;
    case 'colours':
      // The five colours as their first three hex codes: enough to see that they differ.
      return value.split(',').slice(0, 3).join(' ');
    case 'length':
      return formatLength(Number(value));
  }
}

/** "You" for the current user, else the e-mail of the maker; "Music24" when nobody is known. */
export function revisionMakerText(intl: IntlShape, entry: RevisionEntry, currentUserId: number | null): string {
  if (entry.maker === null) {
    return intl.formatMessage(revisionMessages.unknownMaker);
  }
  return entry.maker.id === currentUserId ? intl.formatMessage(revisionMessages.you) : entry.maker.email;
}
